import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.909 18.98c.24 0 .47-.086.64-.26l6.06-5.831c.251-.24.391-.568.391-.905s-.12-.664-.36-.905l-6.06-5.832A.93.93 0 0 0 9.943 5a.93.93 0 0 0-.634.25.86.86 0 0 0-.273.603.86.86 0 0 0 .242.617l.02.019 5.69 5.505-5.72 5.505a.85.85 0 0 0-.02 1.222l.02.02c.17.163.4.259.64.259"
    />
  </svg>
);
export default SvgChevronRight;
